/**
 * WorkflowProgress Component
 *
 * Static workflow instruction indicator for the AI Studio page.
 * Steps: Select Reference → Configure → Generate → Schedule & Post
 */

const WORKFLOW_STEPS = [
  { number: 1, label: 'Select Reference' },
  { number: 2, label: 'Configure' },
  { number: 3, label: 'Generate' },
  { number: 4, label: 'Schedule & Post' },
];

export function WorkflowProgress() {
  return (
    <div className="flex items-center gap-3">
      {WORKFLOW_STEPS.map((step, index) => (
        <div key={step.number} className="flex items-center gap-3">
          <div className="flex items-center gap-2">
            <div className="flex size-6 items-center justify-center rounded-full bg-primary text-xs font-semibold text-primary-foreground">
              {step.number}
            </div>
            <span className="text-sm font-medium text-foreground">
              {step.label}
            </span>
          </div>
          {index < WORKFLOW_STEPS.length - 1 && (
            <div className="h-0.5 w-8 rounded-full bg-primary" />
          )}
        </div>
      ))}
    </div>
  );
}
